import {IVendorDetail} from "../types/IVendorDetail";
import {VendorAnniversaryAwardType} from "./VendorAnniversaryAwardType";

export const doesVendorHaveAnniversaryAward = (vendor: IVendorDetail) => {
    return Object.values(VendorAnniversaryAwardType)
        .filter((key) => typeof key === "number")
        .includes(vendor.id);
};
import {IVendorDetail} from "../types/IVendorDetail";
import {VendorAnniversaryAwardType} from "./VendorAnniversaryAwardType";

export const doesVendorHaveAnniversaryAward = (vendor: IVendorDetail) => {
    return Object.values(VendorAnniversaryAwardType)
        .filter((key) => typeof key === "number")
        .includes(vendor.id);
};
